
// redux (action-types)
import {REMOVE_SESSION} from 'redux/reducers/session/user/action-types'


const revokeUserSession = () => ({type: REMOVE_SESSION})


export {revokeUserSession}